<ng-template #notIdenticalVersAnsprech>
  <span>
    <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung_AnspPtnr) as OE; else isEmpty">
      <app-organization-unit-box-view [data]="OE"  [showAddress]="0" [showContacts]="false"   ></app-organization-unit-box-view>
    </ng-container>
    <!--Change Button + OE is Empty-->
    <ng-template #isEmpty>
      {{ getResource('ChangeOE.NotAssigned') }}
    </ng-template>
    <!--Add Button-->
    <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
       style="color: var(--c-dark);text-decoration: none; display:inline"
       (click)="createOE(
         'aue_oeID_Versicherung_AnspPtnr',
         CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung
       )">
      {{ getResource('add') }}
    </a>
    <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
       style="color: var(--c-dark);text-decoration: none; display:inline"
       (click)="changeOE('aue_oeID_Versicherung_AnspPtnr', CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung)">
      {{ getResource('change') }}
    </a>
    <!--Delete Button-->
    <a *ngIf="excSecurity.isFeatured('CASEEDIT')
  && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung_AnspPtnr) !== undefined
  && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung_AnspPtnr) !== '00000000-0000-0000-0000-000000000000'
  " href="javascript:void(0)"
       style="color: var(--c-dark);text-decoration: none; display:inline"
       (click)="deleteOE('aue_oeID_Versicherung_AnspPtnr')">
      {{ getResource('remove') }}
    </a>
  </span>
</ng-template>

<div class="content grid-1-auto md3-surface app-pad-top-none" [hidden]="CaseSummary?.caseDetails?.isLoading">
  <!--CONTENT-->
  <div class="content flex-container lh-1-15">
      <!--Header-->
      <div class="flex-row app-space-top cols-3">
        <div class="flex-col md3-card-on-surface">
          <div class="content flex-container lh-1-15">
            <div class="flex-row cols-3">
              <div class="flex-col">
                <h4 *ngIf="!editMode">
                  <!-- Auftragsstatus -->
                  {{
                  enumSvc.getEnumerationText(
                    CaseSummary?.caseDetails?.data?.au_enmName_AuftragTyp,
                    CaseSummary?.caseDetails?.data?.au_enmIdent_AuftragTyp)
                  }} -
                  <!-- Auftragsnummer -->
                  {{CaseSummary?.caseDetails?.data?.auNr}}
                </h4>
                <ng-container *ngIf="editMode">
                  <app-exg-select-enumeration [(value)]="uiModel.au_enmIdent_AuftragTyp"
                                              listDisplay="enmText"
                                              enumerationName="AuftragTyp"
                                              name="au_enmIdent_AuftragTyp">
                  </app-exg-select-enumeration>
                </ng-container>
              </div>
              <div class="flex-col spawn">
                <h4 *ngIf="editMode">
                  <!-- Auftragsnummer -->
                  {{CaseSummary?.caseDetails?.data?.auNr}}
                </h4>
              </div>
              <div class="flex-col spawn-reverse">
                <h4>
                    {{
                    enumSvc.getEnumerationText(
                      CaseSummary?.caseDetails?.data?.au_enmName_AuftragStatus,
                      CaseSummary?.caseDetails?.data?.au_enmIdent_AuftragStatus)
                    }}
                </h4>
              </div>
            </div>
            <div class="flex-row cols-3">
              <div class="flex-col app-space-top">
                <!--Auftraggeber-->
                <p class="typo-small">
                  <ng-container>
                    <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber) as OE; else isEmpty">
                      <img [src]="OE.oeLogo
                            ? (OE.oeLogo.startsWith('data:') ? OE.oeLogo : 'data:image/png;base64,' + OE.oeLogo)
                            : 'assets/images/NoImage.png'"
                           alt="Logo"
                           style="max-width: 150px; max-height: 100px; object-fit: contain; display: block; margin-bottom: 0.5rem;">
                      <app-organization-unit-box-view [data]="OE" [showAddress]="0" [showAllContacts]="0" [showContacts]="false"></app-organization-unit-box-view>
                    </ng-container>
                      <!--Change Button + OE is Empty-->
                    <ng-template #isEmpty>
                      {{ getResource('ChangeOE.NotAssigned') }}
                    </ng-template>
                    <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                       style="color: var(--c-dark);text-decoration: none; display:inline"
                       (click)="changeOE('au_oeID_Auftraggeber', '00000000-0000-0000-0000-000000000000', 4, 1)">
                      {{ getResource('change') }}
                    </a>
                      <!--Delete Button-->
                    <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                    && config.getOEByID(CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber) !== undefined
                    && config.getOEByID(CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber) !== '00000000-0000-0000-0000-000000000000'
                    " href="javascript:void(0)"
                       style="color: var(--c-dark);text-decoration: none; display:inline"
                       (click)="deleteOE('au_oeID_Auftraggeber')">
                      {{ getResource('remove') }}
                    </a>
                  </ng-container>
                </p>
              </div>
              <div class="flex-col app-space-top">
                <p class="typo-small">

                  <ng-container *ngIf="!CaseSummary?.caseDetails?.data?.auBeschreibung && !editMode">
                   keine Beschreibung vorhanden
                  </ng-container>
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.auBeschreibung && !editMode">
                    {{CaseSummary?.caseDetails?.data?.auBeschreibung}}
                  </ng-container>
                  <ng-container *ngIf="editMode">
                    <exg-textarea class="app-edit-case-workspace-nospace"
                                  [(ngModel)]="uiModel.auBeschreibung"
                                  type="text" name="auBeschreibung">
                    </exg-textarea>
                  </ng-container>
                </p>
              </div>
              <div class="flex-col app-space-top">
                <p class="typo-small">
                  <!-- Objektbild -->
                  <span>
                    <img alt="thumb"
                         [ngClass]="{'placeholder-img': (!CaseSummary?.caseDetails?.data?.aueObjektbild_dokID || CaseSummary?.caseDetails?.data?.aueObjektbild_dokID === '00000000-0000-0000-0000-000000000000')}"
                         src="{{(!CaseSummary?.caseDetails?.data?.aueObjektbild_dokID || CaseSummary?.caseDetails?.data?.aueObjektbild_dokID === '00000000-0000-0000-0000-000000000000')
                                 ? 'assets/images/NoImage.png'
                                 : excRest.computeUrl('ImageThumbnailBig',
                                        {thumb: 200, dokID: CaseSummary?.caseDetails?.data?.aueObjektbild_dokID})}}"
                         (click)="showObjectImageUpdateModal()"/>
                  </span>
                </p>
              </div>
            </div>
            <div class="flex-row cols-3">
              <div class="flex-col app-space-top">
                <!--Auftraggeber-->
                <p class="typo-small" *ngIf="!editMode">
                  <!-- Schadennummer -->
                  <ng-container
                    *ngIf="CaseSummary?.caseDetails?.data?.aueSchadenNr && CaseSummary?.caseDetails?.data?.aueSchadenNr.length > 0">
                    {{CaseSummary?.caseDetails?.data?.aueSchadenNr}}
                  </ng-container>
                </p>

                <!-- Schadennummer -->
                <p *ngIf="editMode">
                  <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                    [(ngModel)]="uiModel.aueSchadenNr"
                                    name="aueSchadenNr"
                                    type="text">
                  </app-exg-input-v2>
                </p>
              </div>
              <div class="flex-col app-space-top">
                <p class="typo-small">
                  <!-- Versicherungsnehmer -->
                  <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_VN) as OE; else isEmpty">
                    <app-organization-unit-box-view [data]="OE" [showAddress]="0" [showAllContacts]="0" [showContacts]="false"></app-organization-unit-box-view>
                  </ng-container>
                    <!--Change Button + OE is Empty-->
                  <ng-template #isEmpty>
                    {{ getResource('ChangeOE.NotAssigned') }}
                  </ng-template>
                  <!--Add Button-->
                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                     style="color: var(--c-dark);text-decoration: none; display:inline"
                     (click)="createOE('aue_oeID_VN', '00000000-0000-0000-0000-000000000000', 0, 0, false)">
                    {{ getResource('add') }}
                  </a>
                  <!--Change Button-->
                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                     style="color: var(--c-dark);text-decoration: none; display:inline"
                     (click)="changeOE('aue_oeID_VN')">
                    {{ getResource('change') }}
                  </a>
                    <!--Delete Button-->
                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                  && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_VN) !== undefined
                  && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_VN) !== '00000000-0000-0000-0000-000000000000'
                  " href="javascript:void(0)"
                     style="color: var(--c-dark);text-decoration: none; display:inline"
                     (click)="deleteOE('aue_oeID_VN')">
                    {{ getResource('remove') }}
                  </a>
                </p>
              </div>
              <div class="flex-col app-space-top">
                <p class="typo-small">
                  <!-- Schadenort -->
                  <ng-container *ngIf="!editMode && CaseSummary?.Schadenort?.data">
                    <em>{{CaseSummary?.Schadenort?.data.adrStr}} {{CaseSummary?.Schadenort?.data.adrHNum}} </em>
                    <em>{{CaseSummary?.Schadenort?.data.adrPlz}} {{CaseSummary?.Schadenort?.data.adrOrt}}</em>
                  </ng-container>

                  <ng-container *ngIf="editMode">
                    <ng-container *ngIf="uiSchadenort">
                      <em>{{uiSchadenort.adrStr}} {{uiSchadenort.adrHNum}} </em>
                      <em>{{uiSchadenort.adrPlz}} {{uiSchadenort.adrOrt}}</em>
                    </ng-container>

                    <a *ngIf="excSecurity.isFeatured('CASEEDIT')"
                       href="javascript:void(0)"
                       style="color: var(--c-dark);text-decoration: none; display:inline"
                       (click)="openNewAdrModal('aue_adrID_SchadenOrt')">
                      {{ getResource('change') }}
                    </a>
                  </ng-container>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--MAIN CONTENT & TABS-->
      <div class="flex-row cols-3">
        <!--MAIN-->
        <div class="flex-col flex-col-2" #DivDetails>
          <div class="content flex-container lh-1-15">
            <div class="flex-row">
              <div class="flex-col app-space-top md3-card-on-surface">
                <app-exg-tab-v2 #VCrightTabControl
                         [header]="leftTabs">
                <ng-template #pages>
                  <!-- Auftragsdetails     -->
                  <div class="content">
                    <!--NORMAL MODE-->
                    <div class="flex-container-v2 lh-1-15 typo-small"
                         *ngIf="!editMode" >
                      <!-- Schadendaten -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Details.Schadendaten')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Reserve VU -->
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueReserveVU")}}</label>
                              <span>{{CaseSummary?.caseDetails?.data?.aueReserveVU | excCurrency: '€'}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Reserve EXCON -->
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueReserve")}}</label>
                              <span>{{CaseSummary?.caseDetails?.data?.aueReserve | excCurrency: '€'}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!--Schadensumme -->
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadensumme")}}</label>
                              <span>{{CaseSummary?.caseDetails?.data?.aueSchadensumme | excCurrency: '€'}}</span>
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Regulierungssumme -->
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueRegulierungsumme")}}</label>
                              <span>{{CaseSummary?.caseDetails?.data?.aueRegulierungsumme | excCurrency: '€'}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Einsparbetrag -->
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueEinsparbetrag")}}</label>
                              <span>{{CaseSummary?.caseDetails?.data?.aueEinsparbetrag | excCurrency: '€'}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Regressmöglichkeit -->
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                                "aueRegressmoeglichkeit_enmIdent")}}</label>
                              <span>{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.aueRegressmoeglichkeit_enmName,
                                CaseSummary?.caseDetails?.data?.aueRegressmoeglichkeit_enmIdent)}}</span>
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Schadenart -->
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                                "aue_enmIdent_SchadenArt")}}</label>
                              <span>
                                <strong>{{
                                  enumSvc.getEnumerationTextA(
                                    CaseSummary?.caseDetails?.data?.aue_enmName_SchadenArt, CaseSummary?.caseDetails?.data?.aue_enmIdent_SchadenArt
                                  )}} ({{
                                  enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.aue_enmName_SchadenArt, CaseSummary?.caseDetails?.data?.aue_enmIdent_SchadenArt
                                  )}})
                                </strong>
                              </span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Schadenursache -->
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                                "aue_enmIdent_SchadenUrsache")}}</label>
                              <span>{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.aue_enmName_SchadenUrsache,
                                CaseSummary?.caseDetails?.data?.aue_enmIdent_SchadenUrsache)}}</span>
                          </div>
                          <div class="flex-col-v2">

                          </div>
                        </div>
                      </div>
                      <!-- Leistungsgegenstand -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Details.Leistungsgegenstand')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Leistungsgegenstand -->
                            <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueLeistungsgegenstand">
                              <label></label>
                              <span>
                                <ng-container *ngFor="let v of CaseSummary?.caseDetails?.data?.aueLeistungsgegenstand.split('||'); let last = last">
                                  {{enumSvc.getEnumerationText('Leistungsgegenstand', v.replaceAll('|', ''))}}
                                  <ng-container *ngIf="!last"><br></ng-container>
                                </ng-container>
                              </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">

                          </div>
                          <div class="flex-col-v2">

                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">

                          </div>
                          <div class="flex-col-v2">

                          </div>
                          <div class="flex-col-v2">

                          </div>
                        </div>
                      </div>
                      <!-- Sonstiges -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Details.Sonstiges')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">


                            <!-- Reklamation -->
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                                "aueReklamation_enmIdent")}}</label>
                              <span>{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.aueReklamation_enmName,
                                CaseSummary?.caseDetails?.data?.aueReklamation_enmIdent)}}</span>

                          </div>
                          <div class="flex-col-v2">

                            <!-- Abrechnungshinweis -->
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                                "aueAbrechnungshinweis_enmIdent")}}</label>
                              <span>{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmName,
                                CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmIdent)}}</span>

                          </div>
                          <div class="flex-col-v2">
                            <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmIdent && enumSvc.getEnumerationList(enumSvc.getEnumerationItem(CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmName,
                                                 CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmIdent).enmSelector).length > 0">
                              <!-- Abrechnungshinweis Detail -->
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                                "aueAbrechnungshinweisSub1_enmIdent")}}</label>
                              <span>{{enumSvc.getEnumerationText(enumSvc.getEnumerationItem(CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmName,
                                CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmIdent).enmSelector,
                                CaseSummary?.caseDetails?.data?.aueAbrechnungshinweisSub1_enmIdent)}}</span>
                            </ng-container>
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">

                          </div>
                          <div class="flex-col-v2">

                          </div>
                          <div class="flex-col-v2">

                          </div>
                        </div>
                      </div>
                      <!-- Prüfinformation -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2" style="padding-bottom: 0;">
                          <div class="flex-col-v2">
                            <label>{{enumSvc.getFieldCaption('All', '%CKU')}}</label>
                            <span>{{CaseSummary?.caseDetails?.data?.auCKU}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <label>{{enumSvc.getFieldCaption('All', '%CKD')}}</label>
                            <span>{{CaseSummary?.caseDetails?.data?.auCKD | excDate}}</span>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--EDIT MODE DETAILs-->
                    <div class="flex-container-v2 lh-1-15"
                         *ngIf="editMode" >
                      <!-- Schadendaten -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Details.Schadendaten')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Reserve VU -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueReserveVU")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                [ngModel]="uiModel.aueReserveVU"
                                                (ngModelChange)="inputChanged('aueReserveVU', 'number', $event)"
                                                type="number" [step]="0.01"
                                                name="aueReserveVU">
                              </app-exg-input-v2>
                            </span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Reserve EXCON -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueReserve")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                (ngModelChange)="inputChanged('aueReserve', 'number', $event)"
                                                type="number" [step]="0.01"
                                                [ngModel]="uiModel.aueReserve" name="aueReserve">
                              </app-exg-input-v2>
                            </span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Schadensumme -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadensumme")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                (ngModelChange)="inputChanged('aueSchadensumme', 'number', $event)"
                                                type="number" [step]="0.01"
                                                [ngModel]="uiModel.aueSchadensumme" name="aueSchadensumme">
                              </app-exg-input-v2>
                            </span>
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Regulierungssumme -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueRegulierungsumme")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                (ngModelChange)="inputChanged('aueRegulierungsumme', 'number', $event)"
                                                type="number" [step]="0.01"
                                                [ngModel]="uiModel.aueRegulierungsumme" name="aueRegulierungsumme">
                              </app-exg-input-v2>
                            </span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Einsparbetrag -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueEinsparbetrag")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                (ngModelChange)="inputChanged('aueEinsparbetrag', 'number', $event)"
                                                type="number" [step]="0.01"
                                                [ngModel]="uiModel.aueEinsparbetrag" name="aueEinsparbetrag">
                              </app-exg-input-v2>
                            </span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Regressmöglichkeit -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueRegressmoeglichkeit_enmIdent")}}</label>
                            <span>
                              <app-exg-dropdown class="app-edit-case-workspace-nospace"
                                                [list]="enumSvc.getEnumerationList('Regressmoeglichkeit')" listdisplay="enmText"
                                                label="{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.aueRegressmoeglichkeit_enmName, uiModel.aueRegressmoeglichkeit_enmIdent)}}"
                                                maxHeight="250px" position="abovecenter"
                                                (change)="changeEnum($event)">
                              </app-exg-dropdown>
                            </span>
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Schadenart -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS","aue_enmIdent_SchadenArt")}}</label>
                            <span>
                              <app-exg-dropdown class="app-edit-case-workspace-nospace"
                                                [list]="enumSvc.getEnumerationList('Schadenart')"
                                                listdisplay="enmText"
                                                label="{{enumSvc.getEnumerationTextA(CaseSummary?.caseDetails?.data?.aue_enmName_SchadenArt, uiModel.aue_enmIdent_SchadenArt)}}"
                                                maxHeight="250px" position="abovecenter"
                                                (change)="changeEnum($event)">
                              </app-exg-dropdown>
                            </span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Schadenursache -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS","aue_enmIdent_SchadenUrsache")}}</label>
                            <span>
                              <app-exg-dropdown class="app-edit-case-workspace-nospace"
                                                [list]="enumSvc.getEnumerationList(
                                                          enumSvc.getEnumerationItem(
                                                            CaseSummary?.caseDetails?.data?.aue_enmName_SchadenArt
                                                            , uiModel.aue_enmIdent_SchadenArt
                                                          ).enmSelector)"
                                                listdisplay="enmText"
                                                label="{{enumSvc.getEnumerationText(
                                                          enumSvc.getEnumerationItem(CaseSummary?.caseDetails?.data?.aue_enmName_SchadenArt
                                                            , uiModel.aue_enmIdent_SchadenArt).enmSelector
                                                          , uiModel.aue_enmIdent_SchadenUrsache)}}"
                                                maxHeight="250px" position="abovecenter"
                                                (change)="changeEnum($event)">
                              </app-exg-dropdown>
                            </span>
                          </div>
                          <div class="flex-col-v2">

                          </div>
                        </div>
                      </div>
                      <!-- Leistungsgegenstand -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Details.Leistungsgegenstand')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Leistungsgegenstand -->
                            <ng-container *ngFor="let enm of aueLeistungsgegenstandEnmList">
                              <exg-switch [(ngModel)]="enm.enmValue"
                                          (ngModelChange)="computeAueLeistungsgegenstand()"
                                          caption="{{enm.enmText}}"
                                          class=""
                                          [style.font-weight]="'normal'">
                              </exg-switch>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">

                          </div>
                          <div class="flex-col-v2">

                          </div>
                        </div>
                      </div>
                      <!-- Sonstiges -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Details.Sonstiges')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Reklamation -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueReklamation_enmIdent")}}</label>
                            <span>
                              <app-exg-dropdown class="app-edit-case-workspace-nospace"
                                                [list]="enumSvc.getEnumerationList('Reklamation')" listdisplay="enmText"
                                                label="{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.aueReklamation_enmName, uiModel.aueReklamation_enmIdent)}}"
                                                maxHeight="250px" position="abovecenter" (change)="changeEnum($event)">
                              </app-exg-dropdown>
                            </span>
                          </div>
                          <div class="flex-col-v2">
                            <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmName !== ''">
                              <!-- Abrechnungshinweis -->
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAbrechnungshinweis_enmIdent")}}</label>
                              <span>
                                <app-exg-dropdown class="app-edit-case-workspace-nospace"
                                                  [list]="enumSvc.getEnumerationList(CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmName)" listdisplay="enmText"
                                                  label="{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmName, uiModel.aueAbrechnungshinweis_enmIdent)}}"
                                                  maxHeight="250px" position="abovecenter" (change)="changeEnum($event)">
                                </app-exg-dropdown>
                              </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Abrechnungshinweis Detail -->
                            <ng-container *ngIf="enumSvc.getEnumerationList(enumSvc.getEnumerationItem(CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmName,
                                  uiModel.aueAbrechnungshinweis_enmIdent).enmSelector).length > 0">
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAbrechnungshinweisSub1_enmIdent")}}</label>
                              <span>
                                <app-exg-dropdown class="app-edit-case-workspace-nospace"
                                                  [list]="enumSvc.getEnumerationList(enumSvc.getEnumerationItem(CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmName,
                                                          uiModel.aueAbrechnungshinweis_enmIdent).enmSelector)" listdisplay="enmText"
                                                  label="{{enumSvc.getEnumerationText(enumSvc.getEnumerationItem(CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmName,
                                                            uiModel.aueAbrechnungshinweis_enmIdent).enmSelector, uiModel.aueAbrechnungshinweisSub1_enmIdent)}}"
                                                  maxHeight="250px" position="abovecenter" (change)="changeEnum($event)">
                                </app-exg-dropdown>
                              </span>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Versicherungsschutz -->
                  <div class="content" >
                    <!--NORMAL MODE-->
                    <div class="flex-container-v2 lh-1-15 typo-small"
                         *ngIf="!editMode" >
                    <!-- Allgemein -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Versicherung.Versicherung')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Versicherungsart-->
                            <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aue_enmIdent_Versicherungsart &&
                                                  CaseSummary?.caseDetails?.data?.aue_enmIdent_Versicherungsart !== 0">
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                                "aue_enmIdent_Versicherungsart")}}</label>
                              <span>{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.aue_enmName_Versicherungsart,
                                CaseSummary?.caseDetails?.data?.aue_enmIdent_Versicherungsart)}}</span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Ansprechpartner -->
                            <ng-container>
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS","aue_oeID_AnspPtnr")}}</label>
                              <span>
                                <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) as OE; else isEmpty">
                                  <app-organization-unit-box-view [data]="OE"  [showAddress]="0" [showContacts]="false"   ></app-organization-unit-box-view>
                                </ng-container>
                                <!--Change Button + OE is Empty-->
                                <ng-template #isEmpty>
                                  {{ getResource('ChangeOE.NotAssigned') }}
                                </ng-template>
                                <!--Add Button-->
                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="createOE('aue_oeID_AnspPtnr')">
                                  {{ getResource('add') }}
                                </a>
                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="changeOE('aue_oeID_AnspPtnr')">
                                  {{ getResource('change') }}
                                </a>
                                <!--Delete Button-->
                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                                && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) !== undefined
                                && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) !== '00000000-0000-0000-0000-000000000000'
                                " href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="deleteOE('aue_oeID_AnspPtnr')">
                                  {{ getResource('remove') }}
                                </a>
                              </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Versicherungsnummer -->
                            <label>{{enumSvc.getFieldCaption("Auftrag", "auOKZ")}}</label>
                            <span>{{CaseSummary?.caseDetails?.data?.auOKZ}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">

                            <!-- Versicherungssumme-->
                            <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueVersicherungSumme">
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueVersicherungSumme")}}</label>
                              <span>{{CaseSummary?.caseDetails?.data?.aueVersicherungSumme | excCurrency: '€'}}</span>
                            </ng-container>

                          </div>
                          <div class="flex-col-v2">

                            <!-- Wert1914 -->
                            <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueWert1914">
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                                "aueWert1914")}}</label>
                              <span>{{CaseSummary?.caseDetails?.data?.aueWert1914 | excCurrency: '€'}}</span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">


                            <!-- Selbstbehalt -->
                            <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueSelbstbehalt">
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSelbstbehalt")}}</label>
                              <span>{{CaseSummary?.caseDetails?.data?.aueSelbstbehalt | excCurrency: '€'}}</span>
                            </ng-container>
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">

                            <!-- Hinweise Entschädigungsgrenze -->
                            <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueHinweiseEntschaedigungsgrenze">
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueHinweiseEntschaedigungsgrenze")}}</label>
                              <span>{{CaseSummary?.caseDetails?.data?.aueHinweiseEntschaedigungsgrenze}}</span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--EDIT MODE VERSICHERUNG-->
                    <div class="flex-container-v2 lh-1-15"
                         *ngIf="editMode">
                      <!-- Versicherung -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Versicherung.Versicherung')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Versicherungsart -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aue_enmIdent_Versicherungsart")}}</label>
                            <span>
                              <app-exg-dropdown class="app-edit-case-workspace-nospace"
                                                [list]="enumSvc.getEnumerationList('Versicherungsart')" listdisplay="enmText"
                                                label="{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.aue_enmName_Versicherungsart, uiModel.aue_enmIdent_Versicherungsart)}}"
                                                maxHeight="250px" position="abovecenter" (change)="changeEnum($event)">
                              </app-exg-dropdown>
                            </span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Ansprechpartner -->
                            <ng-container>
                              <label>{{enumSvc.getFieldCaption("AuftragE_EIS","aue_oeID_AnspPtnr")}}</label>
                              <span>
                                <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) as OE; else isEmpty">
                                  <app-organization-unit-box-view [data]="OE"  [showAddress]="0" [showContacts]="false"   ></app-organization-unit-box-view>
                                </ng-container>
                                      <!--Change Button + OE is Empty-->
                                <ng-template #isEmpty>
                                  {{ getResource('ChangeOE.NotAssigned') }}
                                </ng-template>
                                <!--Add Button-->
                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="createOE('aue_oeID_AnspPtnr')">
                                  {{ getResource('add') }}
                                </a>
                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="changeOE('aue_oeID_AnspPtnr')">
                                  {{ getResource('change') }}
                                </a>
                                      <!--Delete Button-->
                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                                && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) !== undefined
                                && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) !== '00000000-0000-0000-0000-000000000000'
                                " href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="deleteOE('aue_oeID_AnspPtnr')">
                                  {{ getResource('remove') }}
                                </a>
                              </span>
                            </ng-container>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Versicherungsnummer -->
                            <label>{{enumSvc.getFieldCaption("Auftrag", "auOKZ")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                type="text" [(ngModel)]="uiModel.auOKZ" name="auOKZ">
                              </app-exg-input-v2>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Versicherungssumme (berechnet) -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueVersicherungSumme")}}</label>
                            <span>{{uiModel.aueWert1914 * CaseSummary?.wert1914Faktor?.data | excCurrency: '€'}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Wert1914 -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS","aueWert1914")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                (ngModelChange)="inputChanged('aueWert1914', 'number', $event)"
                                                type="number" [step]="0.01"
                                                [ngModel]=uiModel.aueWert1914 name="aueWert1914">
                              </app-exg-input-v2>
                            </span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Selbstbehalt -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSelbstbehalt")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                (ngModelChange)="inputChanged('aueSelbstbehalt', 'number', $event)"
                                                type="number" [step]="0.01"
                                                [ngModel]=uiModel.aueSelbstbehalt name="aueSelbstbehalt">
                              </app-exg-input-v2>
                            </span>
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Hinweise Entschädigungsgrenze -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueHinweiseEntschaedigungsgrenze")}}</label>
                            <span>
                              <exg-textarea class="app-edit-case-workspace-nospace"
                                            type="text" [(ngModel)]="uiModel.aueHinweiseEntschaedigungsgrenze"
                                            name="aueHinweiseEntschaedigungsgrenze">
                              </exg-textarea>
                            </span>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Ablauf -->
                  <div class="content" >
                    <!--NORMAL MODE-->
                    <div class="flex-container-v2 lh-1-15 typo-small"
                         *ngIf="!editMode" >
                      <!-- Allgemein -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Ablauf.Allgemein')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!--Auftraggeber-->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAuftragsdatum")}}</label>
                            <span>{{CaseSummary?.caseDetails?.data?.aueAuftragsdatum | excDate}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Ansprechpartner -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenDatum")}}</label>
                            <span>{{CaseSummary?.caseDetails?.data?.aueSchadenDatum | excDate}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                              "aueAbrechnungshinweisDatum")}}</label>
                            <span>{{CaseSummary?.caseDetails?.data?.aueAbrechnungshinweisDatum | excDate}}</span>
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!--Auftraggeber-->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenmeldungVU")}}</label>
                            <span>{{CaseSummary?.caseDetails?.data?.aueSchadenmeldungVU | excDate}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Ansprechpartner -->
                           </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                      </div>
                      <!-- Ablauf -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Ablauf.Ablauf')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Ortstermin geplant -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtsterminPlan")}}</label>
                            <span>{{CaseSummary?.caseDetails?.data?.aueOrtsterminPlan | excDate}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Kontaktaufnahme -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueKontaktaufnahme")}}</label>
                            <span>{{CaseSummary?.caseDetails?.data?.aueKontaktaufnahme | excDate}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Ortstermin -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtstermin")}}</label>
                            <span>{{CaseSummary?.caseDetails?.data?.aueOrtstermin | excDate}}</span>
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- 2.Ortstermin -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtstermin2")}}</label>
                            <span>{{CaseSummary?.caseDetails?.data?.aueOrtstermin2 | excDate}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Weitere Ortstermine -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueWeitereOrtstermine")}}</label>
                            <span>{{CaseSummary?.caseDetails?.data?.aueWeitereOrtstermine}}</span>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                      </div>
                      <!-- Abschluss -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Ablauf.Abschluss')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Abschlussdatum -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAbschlussdatum")}}</label>
                            <span>{{CaseSummary?.caseDetails?.data?.aueAbschlussdatum | excDate}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Fristverlängerung -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueFristverlaengerungBis")}}</label>
                            <span>{{CaseSummary?.caseDetails?.data?.aueFristverlaengerungBis | excDate}}</span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Datum Zwischenbericht -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueZwischenberichtDatum")}}</label>
                            <span>{{CaseSummary?.caseDetails?.data?.aueZwischenberichtDatum | excDate}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex-container-v2 lh-1-15"
                         *ngIf="editMode" >
                      <!-- Allgemein -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Ablauf.Allgemein')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Auftragsdatum -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAuftragsdatum")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                [ngModel]="uiModel.aueAuftragsdatum"
                                                (ngModelChange)="inputChanged('aueAuftragsdatum', 'date', $event)"
                                                name="aueAuftragsdatum"
                                                type="date" [isEpoch]="true">
                              </app-exg-input-v2>
                            </span>
                          </div>
                          <div class="flex-col-v2">
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenDatum")}}</label>
                            <!-- SchadenDatum -->
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                [ngModel]="uiModel.aueSchadenDatum"
                                                (ngModelChange)="inputChanged('aueSchadenDatum', 'date', $event)"
                                                name="aueSchadenDatum"
                                                type="date" [isEpoch]="true">
                              </app-exg-input-v2>
                            </span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Belegprüfung Inklusiveleistung bis -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAbrechnungshinweisDatum")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                [ngModel]="uiModel.aueAbrechnungshinweisDatum"
                                                (ngModelChange)="inputChanged('aueAbrechnungshinweisDatum', 'date', $event)"
                                                name="aueAbrechnungshinweisDatum"
                                                type="date" [isEpoch]="true">
                              </app-exg-input-v2>
                            </span>
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Schadenmeldung VU -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenmeldungVU")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                [ngModel]="uiModel.aueSchadenmeldungVU"
                                                (ngModelChange)="inputChanged('aueSchadenmeldungVU', 'date', $event)"
                                                name="aueSchadenmeldungVU"
                                                type="date" [isEpoch]="true">
                              </app-exg-input-v2>
                            </span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Ansprechpartner -->
                           </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                      </div>
                      <!-- Ablauf -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Ablauf.Ablauf')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Ortstermin geplant -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtsterminPlan")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                [ngModel]="uiModel.aueOrtsterminPlan"
                                                (ngModelChange)="inputChanged('aueOrtsterminPlan', 'date', $event)"
                                                name="aueOrtsterminPlan"
                                                type="date" [isEpoch]="true">
                              </app-exg-input-v2>
                            </span>
                          </div>
                          <div class="flex-col-v2">

                            <!-- Kontaktaufnahme -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueKontaktaufnahme")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                [ngModel]="uiModel.aueKontaktaufnahme"
                                                (ngModelChange)="inputChanged('aueKontaktaufnahme', 'date', $event)"
                                                name="aueKontaktaufnahme"
                                                type="date" [isEpoch]="true">
                              </app-exg-input-v2>
                            </span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Ortstermin -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtstermin")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                         [ngModel]="uiModel.aueOrtstermin"
                                                (ngModelChange)="inputChanged('aueOrtstermin', 'date', $event)"
                                                name="aueOrtstermin"
                                         type="date" [isEpoch]="true">
                              </app-exg-input-v2>
                            </span>
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- 2.Ortstermin -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtstermin2")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                [ngModel]="uiModel.aueOrtstermin2"
                                                (ngModelChange)="inputChanged('aueOrtstermin2', 'date', $event)"
                                                name="aueOrtstermin2"
                                                type="date" [isEpoch]="true">
                              </app-exg-input-v2>
                            </span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Weitere Ortstermine -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueWeitereOrtstermine")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                [(ngModel)]="uiModel.aueWeitereOrtstermine"
                                                name="aueWeitereOrtstermine"
                                                type="text">
                              </app-exg-input-v2>
                            </span>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                      </div>
                      <!-- Abschluss -->
                      <div class="flex-card-v2">
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <h4>{{getRessource('TabTitle.Ablauf.Abschluss')}}</h4>
                          </div>
                          <div class="flex-col-v2">
                          </div>
                          <div class="flex-col-v2">
                          </div>
                        </div>
                        <div class="flex-row-v2">
                          <div class="flex-col-v2">
                            <!-- Abschlussdatum -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAbschlussdatum")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                [ngModel]="uiModel.aueAbschlussdatum"
                                                (ngModelChange)="inputChanged('aueAbschlussdatum', 'date', $event)"
                                                name="aueAbschlussdatum"
                                                type="date" [isEpoch]="true">
                              </app-exg-input-v2>
                            </span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Fristverlängerung -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueFristverlaengerungBis")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                [ngModel]="uiModel.aueFristverlaengerungBis"
                                                (ngModelChange)="inputChanged('aueFristverlaengerungBis', 'date', $event)"
                                                name="aueFristverlaengerungBis"
                                                type="date" [isEpoch]="true">
                              </app-exg-input-v2>
                            </span>
                          </div>
                          <div class="flex-col-v2">
                            <!-- Datum Zwischenbericht -->
                            <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueZwischenberichtDatum")}}</label>
                            <span>
                              <app-exg-input-v2 class="app-edit-case-workspace-nospace"
                                                [ngModel]="uiModel.aueZwischenberichtDatum"
                                                (ngModelChange)="inputChanged('aueZwischenberichtDatum', 'date', $event)"
                                                name="aueZwischenberichtDatum"
                                                type="date" [isEpoch]="true">
                              </app-exg-input-v2>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Ansprechpartner -->
	                <div class="content" >
		                <div class="flex-container-v2 lh-1-15 typo-small">
			                <!-- Auftraggeber -->
			                <div class="flex-card-v2">
				                <div class="flex-row-v2">
					                <div class="flex-col-v2">
						                <h4>{{enumSvc.getFieldCaption("Auftrag", "au_oeID_Auftraggeber")}}</h4>
					                </div>
					                <div class="flex-col-v2">
					                </div>
					                <div class="flex-col-v2">
					                </div>
				                </div>
				                <div class="flex-row-v2">
					                <div class="flex-col-v2">
						                <!--Auftraggeber-->
						                <ng-container>
							                <label>{{enumSvc.getFieldCaption("Auftrag", "au_oeID_Auftraggeber")}}</label>

							                <span>
                                <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber) as OE; else isEmpty">
                                  <app-organization-unit-box-view [data]="OE" [showAddress]="0" [showContacts]="false"   ></app-organization-unit-box-view>
                                </ng-container>
								                <!--Change Button + OE is Empty-->
                                <ng-template #isEmpty>
                                  {{ getResource('ChangeOE.NotAssigned') }}
                                </ng-template>
                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="changeOE('au_oeID_Auftraggeber', '00000000-0000-0000-0000-000000000000', 4, 1)">
                                  {{ getResource('change') }}
                                </a>
								                <!--Delete Button-->
                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber) !== undefined
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber) !== '00000000-0000-0000-0000-000000000000'
                      " href="javascript:void(0)"
                                   style="color: var(--c-dark);text-decoration: none; display:inline"
                                   (click)="deleteOE('au_oeID_Auftraggeber')">
                                  {{ getResource('remove') }}
                                </a>
                                </span>
						                </ng-container>
					                </div>
					                <div class="flex-col-v2">
						                <!-- Ansprechpartner -->
						                <ng-container>
							                <label>{{enumSvc.getFieldCaption("Auftrag", "au_oeId_Ansprechpartner")}}</label>
							                <span>
                          <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.au_oeId_Ansprechpartner) as OE; else isEmpty">
                            <app-organization-unit-box-view [data]="OE"  [showAddress]="0" [showContacts]="false"   ></app-organization-unit-box-view>
                          </ng-container>
								                <!--Change Button + OE is Empty-->
                          <ng-template #isEmpty>
                            {{ getResource('ChangeOE.NotAssigned') }}
                          </ng-template>
                                <!--Add Button-->
                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                             style="color: var(--c-dark);text-decoration: none; display:inline"
                             (click)="createOE('au_oeId_Ansprechpartner', CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber)">
                            {{ getResource('add') }}
                          </a>
                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                             style="color: var(--c-dark);text-decoration: none; display:inline"
                             (click)="changeOE('au_oeId_Ansprechpartner', CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber)">
                            {{ getResource('change') }}
                          </a>
								                <!--Delete Button-->
                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                          && config.getOEByID(CaseSummary?.caseDetails?.data?.au_oeId_Ansprechpartner) !== undefined
                          && config.getOEByID(CaseSummary?.caseDetails?.data?.au_oeId_Ansprechpartner) !== '00000000-0000-0000-0000-000000000000'
                          " href="javascript:void(0)"
                             style="color: var(--c-dark);text-decoration: none; display:inline"
                             (click)="deleteOE('au_oeId_Ansprechpartner')">
                            {{ getResource('remove') }}
                          </a>
                        </span>
						                </ng-container>
					                </div>
					                <div class="flex-col-v2">
						                <label></label>
					                </div>
				                </div>
			                </div>
			                <!-- Versicherung -->
			                <div class="flex-card-v2">
				                <div class="flex-row-v2">
					                <div class="flex-col-v2">
						                <h4>
							                {{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_VN")}}
						                </h4>
					                </div>
					                <div class="flex-col-v2">
					                </div>
					                <div class="flex-col-v2">
					                </div>
				                </div>
				                <div class="flex-row-v2">
					                <div class="flex-col-v2">
						                <!-- Versicherungsnehmer -->
						                <ng-container>
							                <label>
								                {{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_VN")}}
							                </label>
							                <span>
	                                <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_VN) as OE; else isEmpty">
	                                  <app-organization-unit-box-view [data]="OE"  [showAddress]="0" [showContacts]="false"   ></app-organization-unit-box-view>
	                                </ng-container>
								                <!--Change Button + OE is Empty-->
	                                <ng-template #isEmpty>
	                                  {{ getResource('ChangeOE.NotAssigned') }}
	                                </ng-template>
                                <!--Add Button-->
                                 <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                    style="color: var(--c-dark);text-decoration: none; display:inline"
                                    (click)="createOE('aue_oeID_VN', '00000000-0000-0000-0000-000000000000', 0, 0, false)">
	                                  {{ getResource('add') }}
	                                </a>
                                <!--Change Button-->
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
	                                   style="color: var(--c-dark);text-decoration: none; display:inline"
	                                   (click)="changeOE('aue_oeID_VN')">
	                                  {{ getResource('change') }}
	                                </a>
								                <!--Delete Button-->
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                                && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_VN) !== undefined
	                                && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_VN) !== '00000000-0000-0000-0000-000000000000'
	                                " href="javascript:void(0)"
	                                   style="color: var(--c-dark);text-decoration: none; display:inline"
	                                   (click)="deleteOE('aue_oeID_VN')">
	                                  {{ getResource('remove') }}
	                                </a>
	                              </span>
						                </ng-container>
					                </div>
					                <div class="flex-col-v2">
						                <!-- Versicherung -->
						                <ng-container>
							                <label>
								                {{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_Versicherung")}}
							                </label>
							                <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung ===
	                              CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber
	                              && CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber !== '00000000-0000-0000-0000-000000000000'
	                              ; else notIdenticalVersicherung
	                              ">
	                                <span>{{getRessource('ChangeOE.sameAsAG')}}
		                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
		                                   style="color: var(--c-dark);text-decoration: none; display:inline"
		                                   (click)="changeOE('aue_oeID_Versicherung', '00000000-0000-0000-0000-000000000000', 4, 1)">
	                                    {{getResource('change')}}
	                                  </a>
	                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
	                                     style="color: var(--c-dark);text-decoration: none; display:inline"
	                                     (click)="deleteOE('aue_oeID_Versicherung')">
	                                    {{getResource('remove')}}
	                                  </a></span>
							                </ng-container>
							                <ng-template #notIdenticalVersicherung>
	                                <span>
	                                  <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung) as OE; else isEmpty">
	                                    <app-organization-unit-box-view [data]="OE"  [showAddress]="0" [showContacts]="false"   ></app-organization-unit-box-view>
	                                  </ng-container>
		                                <!--Change Button + OE is Empty-->
	                                  <ng-template #isEmpty>
	                                    {{ getResource('ChangeOE.NotAssigned') }}
	                                  </ng-template>
	                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
	                                     style="color: var(--c-dark);text-decoration: none; display:inline"
	                                     (click)="changeOE('aue_oeID_Versicherung', '00000000-0000-0000-0000-000000000000', 4, 1)">
	                                    {{ getResource('change') }}
	                                  </a>
		                                <!--Delete Button-->
	                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                                && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung) !== undefined
	                                && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung) !== '00000000-0000-0000-0000-000000000000'
	                                " href="javascript:void(0)"
	                                     style="color: var(--c-dark);text-decoration: none; display:inline"
	                                     (click)="deleteOE('aue_oeID_Versicherung')">
	                                    {{ getResource('remove') }}
	                                  </a>
	                                </span>
							                </ng-template>
						                </ng-container>
					                </div>
					                <div class="flex-col-v2">
						                <!-- Anspruchsteller-->
						                <ng-container>
							                <label>{{enumSvc.getFieldCaption("AuftragE_EIS","aueAnspruchsteller")}}</label>
							                <span>
	                          <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Anspruchsteller) as OE; else isEmpty">
	                            <app-organization-unit-box-view [data]="OE"  [showAddress]="0" [showContacts]="false"   ></app-organization-unit-box-view>
	                          </ng-container>
								                <!--Change Button + OE is Empty-->
	                          <ng-template #isEmpty>
	                            {{ getResource('ChangeOE.NotAssigned') }}
	                          </ng-template>
                            <!--Add Button-->
                            <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                               style="color: var(--c-dark);text-decoration: none; display:inline"
                               (click)="createOE('aue_oeID_Anspruchsteller')">
                              {{ getResource('add') }}
                            </a>
	                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
	                             style="color: var(--c-dark);text-decoration: none; display:inline"
	                             (click)="changeOE('aue_oeID_Anspruchsteller')">
	                            {{ getResource('change') }}
	                          </a>
								                <!--Delete Button-->
	                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                          && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Anspruchsteller) !== undefined
	                          && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Anspruchsteller) !== '00000000-0000-0000-0000-000000000000'
	                          " href="javascript:void(0)"
	                             style="color: var(--c-dark);text-decoration: none; display:inline"
	                             (click)="deleteOE('aue_oeID_Anspruchsteller')">
	                            {{ getResource('remove') }}
	                          </a>
	                        </span>
						                </ng-container>
					                </div>
				                </div>
				                <div class="flex-row-v2">
					                <div class="flex-col-v2">
						                <!-- Ansprechpartner -->
						                <ng-container>
							                <label>{{enumSvc.getFieldCaption("AuftragE_EIS","aue_oeID_AnspPtnr")}}</label>
							                <span>
                          <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) as OE; else isEmpty">
                            <app-organization-unit-box-view [data]="OE"  [showAddress]="0" [showContacts]="false"   ></app-organization-unit-box-view>
                          </ng-container>
								                <!--Change Button + OE is Empty-->
                          <ng-template #isEmpty>
                            {{ getResource('ChangeOE.NotAssigned') }}
                          </ng-template>
                          <!--Add Button-->
                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                             style="color: var(--c-dark);text-decoration: none; display:inline"
                             (click)="createOE('aue_oeID_AnspPtnr')">
                            {{ getResource('add') }}
                          </a>
                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                             style="color: var(--c-dark);text-decoration: none; display:inline"
                             (click)="changeOE('aue_oeID_AnspPtnr')">
                            {{ getResource('change') }}
                          </a>
								                <!--Delete Button-->
                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                          && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) !== undefined
                          && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) !== '00000000-0000-0000-0000-000000000000'
                          " href="javascript:void(0)"
                             style="color: var(--c-dark);text-decoration: none; display:inline"
                             (click)="deleteOE('aue_oeID_AnspPtnr')">
                            {{ getResource('remove') }}
                          </a>
                        </span>
						                </ng-container>
					                </div>
					                <div class="flex-col-v2">
						                <!-- Ansprechpartner-->
						                <ng-container>
							                <label>
								                {{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_Versicherung_AnspPtnr")}}
							                </label>
							                <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung_AnspPtnr === CaseSummary?.caseDetails?.data?.au_oeId_Ansprechpartner
                                                  && CaseSummary?.caseDetails?.data?.au_oeId_Ansprechpartner !== '00000000-0000-0000-0000-000000000000'
                                                  ; else notIdenticalVersAnsprech
                              ">
                                <span>
                                  {{getRessource('ChangeOE.sameAsAG')}}
                                  <!--Add Button-->
                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="createOE('aue_oeID_Versicherung_AnspPtnr', CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung)">
                                    {{ getResource('add') }}
                                  </a>
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
	                                   style="color: var(--c-dark);text-decoration: none; display:inline"
	                                   (click)="changeOE('aue_oeID_Versicherung_AnspPtnr', CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung)">
                                    {{getResource('change')}}
                                  </a>
                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="deleteOE('aue_oeID_Versicherung_AnspPtnr')">
                                    {{getResource('remove')}}
                                  </a>
                                </span>
							                </ng-container>
						                </ng-container>
					                </div>
					                <div class="flex-col-v2">
					                </div>
				                </div>
			                </div>
			                <!-- Ansprechpartner -->
			                <div class="flex-card-v2">
				                <div class="flex-row-v2">
					                <div class="flex-col-v2">
						                <h4>
							                {{
                                enumSvc.getEnumerationText(
                                    CaseSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion, 0
                                )
							                }}
						                </h4>
					                </div>
					                <div class="flex-col-v2">
					                </div>
					                <div class="flex-col-v2">
					                </div>
				                </div>
				                <div class="flex-row-v2">
					                <div class="flex-col-v2">
						                <!-- Weiterer Ansprechpartner 1-->
						                <ng-container>
							                <label>
								                {{ enumSvc.getEnumerationText(
                                  CaseSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion,
                                  CaseSummary?.caseDetails?.data?.aue_enmIdent_WAnsprPtnr1Funktion)
								                }}
							                </label>
							                <span>
	                                <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr1) as OE; else isEmpty">
	                                  <app-organization-unit-box-view [data]="OE"  [showAddress]="0" [showContacts]="false"   ></app-organization-unit-box-view>
	                                </ng-container>
								                <!--Change Button + OE is Empty-->
	                                <ng-template #isEmpty>
	                                  {{ getResource('ChangeOE.NotAssigned') }}
	                                </ng-template>
                                  <!--Add Button-->
                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="createOE('aue_oeID_WAnsprPtnr1')">
                                    {{ getResource('add') }}
                                  </a>
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
	                                   style="color: var(--c-dark);text-decoration: none; display:inline"
	                                   (click)="changeOE('aue_oeID_WAnsprPtnr1')">
	                                  {{ getResource('change') }}
	                                </a>
								                <!--Delete Button-->
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                                && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr1) !== undefined
	                                && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr1) !== '00000000-0000-0000-0000-000000000000'
	                                " href="javascript:void(0)"
	                                   style="color: var(--c-dark);text-decoration: none; display:inline"
	                                   (click)="deleteOE('aue_oeID_WAnsprPtnr1')">
	                                  {{ getResource('remove') }}
	                                </a>
	                              </span>
						                </ng-container>
					                </div>
					                <div class="flex-col-v2">
						                <!-- Weiterer Ansprechpartner 2 -->
						                <ng-container>
							                <label>
								                {{ enumSvc.getEnumerationText(
                                  CaseSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion,
                                  CaseSummary?.caseDetails?.data?.aue_enmIdent_WAnsprPtnr2Funktion)
								                }}
							                </label>
							                <span>
	                                <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr2) as OE; else isEmpty">
	                                  <app-organization-unit-box-view [data]="OE"  [showAddress]="0" [showContacts]="false"   ></app-organization-unit-box-view>
	                                </ng-container>
								                <!--Change Button + OE is Empty-->
	                                <ng-template #isEmpty>
	                                  {{ getResource('ChangeOE.NotAssigned') }}
	                                </ng-template>
                                  <!--Add Button-->
                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="createOE('aue_oeID_WAnsprPtnr2')">
                                    {{ getResource('add') }}
                                  </a>
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
	                                   style="color: var(--c-dark);text-decoration: none; display:inline"
	                                   (click)="changeOE('aue_oeID_WAnsprPtnr2')">
	                                  {{ getResource('change') }}
	                                </a>
								                <!--Delete Button-->
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                                && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr2) !== undefined
	                                && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr2) !== '00000000-0000-0000-0000-000000000000'
	                                " href="javascript:void(0)"
	                                   style="color: var(--c-dark);text-decoration: none; display:inline"
	                                   (click)="deleteOE('aue_oeID_WAnsprPtnr2')">
	                                  {{ getResource('remove') }}
	                                </a>
	                              </span>
						                </ng-container>
					                </div>
					                <div class="flex-col-v2">
						                <!-- Weiterer Ansprechpartner 3 -->
						                <ng-container>
							                <label>
								                {{ enumSvc.getEnumerationText(
                                  CaseSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion,
                                  CaseSummary?.caseDetails?.data?.aue_enmIdent_WAnsprPtnr3Funktion)
								                }}
							                </label>
							                <span>
	                                <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr3) as OE; else isEmpty">
	                                  <app-organization-unit-box-view [data]="OE"  [showAddress]="0" [showContacts]="false"   ></app-organization-unit-box-view>
	                                </ng-container>
								                <!--Change Button + OE is Empty-->
	                                <ng-template #isEmpty>
	                                  {{ getResource('ChangeOE.NotAssigned') }}
	                                </ng-template>
                                  <!--Add Button-->
                                  <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                                     style="color: var(--c-dark);text-decoration: none; display:inline"
                                     (click)="createOE('aue_oeID_WAnsprPtnr3')">
                                    {{ getResource('add') }}
                                  </a>
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
	                                   style="color: var(--c-dark);text-decoration: none; display:inline"
	                                   (click)="changeOE('aue_oeID_WAnsprPtnr3')">
	                                  {{ getResource('change') }}
	                                </a>
								                <!--Delete Button-->
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                                && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr3) !== undefined
	                                && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr3) !== '00000000-0000-0000-0000-000000000000'
	                                " href="javascript:void(0)"
	                                   style="color: var(--c-dark);text-decoration: none; display:inline"
	                                   (click)="deleteOE('aue_oeID_WAnsprPtnr3')">
	                                  {{ getResource('remove') }}
	                                </a>
	                              </span>
						                </ng-container>
					                </div>
				                </div>
				                <div class="flex-row-v2">
					                <div class="flex-col-v2">
						                <!-- Weiterer Ansprechpartner 4 -->
						                <ng-container>
							                <label>{{ enumSvc.getEnumerationText(
                                  CaseSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion,
                                  CaseSummary?.caseDetails?.data?.aue_enmIdent_WAnsprPtnr4Funktion)
								                }}
							                </label>
							                <span>
                            <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr4) as OE; else isEmpty">
                              <app-organization-unit-box-view [data]="OE"  [showAddress]="0" [showContacts]="false"   ></app-organization-unit-box-view>
                            </ng-container>
								                <!--Change Button + OE is Empty-->
                            <ng-template #isEmpty>
                              {{ getResource('ChangeOE.NotAssigned') }}
                            </ng-template>
                            <!--Add Button-->
                            <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                               style="color: var(--c-dark);text-decoration: none; display:inline"
                               (click)="createOE('aue_oeID_WAnsprPtnr4')">
                              {{ getResource('add') }}
                            </a>
                            <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                               style="color: var(--c-dark);text-decoration: none; display:inline"
                               (click)="changeOE('aue_oeID_WAnsprPtnr4')">
                              {{ getResource('change') }}
                            </a>
								                <!--Delete Button-->
                            <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                              && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr4) !== undefined
                              && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr4) !== '00000000-0000-0000-0000-000000000000'
                              " href="javascript:void(0)"
                               style="color: var(--c-dark);text-decoration: none; display:inline"
                               (click)="deleteOE('aue_oeID_WAnsprPtnr4')">
                                {{ getResource('remove') }}
                              </a>
                            </span>
						                </ng-container>
					                </div>
					                <div class="flex-col-v2">
					                </div>
					                <div class="flex-col-v2">
					                </div>
				                </div>
			                </div>
			                <!-- letzter ... -->
			                <div class="flex-card-v2">
				                <div class="flex-row-v2">
					                <div class="flex-col-v2">
						                <!-- Letzter Sachverständiger-->
						                <ng-container>
							                <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueLetzterSachverstaendiger")}}</label>
							                <span>
	                                <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterSachverstaendiger) as OE; else isEmpty">
	                                  <app-organization-unit-box-view [data]="OE"  [showAddress]="0" [showContacts]="false"   ></app-organization-unit-box-view>
	                                </ng-container>
								                <!--Change Button + OE is Empty-->
	                                <ng-template #isEmpty>
	                                  {{ getResource('ChangeOE.NotAssigned') }}
	                                </ng-template>
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
	                                   style="color: var(--c-dark);text-decoration: none; display:inline"
	                                   (click)="changeOE('aue_oeID_letzterSachverstaendiger')">
	                                  {{ getResource('change') }}
	                                </a>
								                <!--Delete Button-->
	                                <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                                && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterSachverstaendiger) !== undefined
	                                && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterSachverstaendiger) !== '00000000-0000-0000-0000-000000000000'
	                                " href="javascript:void(0)"
	                                   style="color: var(--c-dark);text-decoration: none; display:inline"
	                                   (click)="deleteOE('aue_oeID_letzterSachverstaendiger')">
	                                  {{ getResource('remove') }}
	                                </a>
	                              </span>
						                </ng-container>
					                </div>
					                <div class="flex-col-v2">
						                <!-- Letzter QS-Prüfer -->
						                <ng-container>
							                <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueLetzterQSPruefer")}}</label>
							                <span>
	                          <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterQSPruefer) as OE; else isEmpty">
	                            <app-organization-unit-box-view [data]="OE"  [showAddress]="0" [showContacts]="false"   ></app-organization-unit-box-view>
	                          </ng-container>
								                <!--Change Button + OE is Empty-->
	                          <ng-template #isEmpty>
	                            {{ getResource('ChangeOE.NotAssigned') }}
	                          </ng-template>
	                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
	                             style="color: var(--c-dark);text-decoration: none; display:inline"
	                             (click)="changeOE('aue_oeID_letzterQSPruefer')">
	                            {{ getResource('change') }}
	                          </a>
								                <!--Delete Button-->
	                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                          && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterQSPruefer) !== undefined
	                          && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterQSPruefer) !== '00000000-0000-0000-0000-000000000000'
	                          " href="javascript:void(0)"
	                             style="color: var(--c-dark);text-decoration: none; display:inline"
	                             (click)="deleteOE('aue_oeID_letzterQSPruefer')">
	                            {{ getResource('remove') }}
	                          </a>
	                        </span>
						                </ng-container>
					                </div>
					                <div class="flex-col-v2">
						                <!-- Letzter Sanierungspartner-->
						                <ng-container>
							                <label>{{enumSvc.getFieldCaption("AuftragE_EIS","aueLetzterSanierungspartner")}}</label>
							                <span>
	                          <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterSanierungspartner) as OE; else isEmpty">
	                            <app-organization-unit-box-view [data]="OE"  [showAddress]="0" [showContacts]="false"   ></app-organization-unit-box-view>
	                          </ng-container>
								                <!--Change Button + OE is Empty-->
	                          <ng-template #isEmpty>
	                            {{ getResource('ChangeOE.NotAssigned') }}
	                          </ng-template>
	                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
	                             style="color: var(--c-dark);text-decoration: none; display:inline"
	                             (click)="changeOE('aue_oeID_letzterSanierungspartner', '00000000-0000-0000-0000-000000000000', 4, 1)">
	                            {{ getResource('change') }}
	                          </a>
								                <!--Delete Button-->
	                          <a *ngIf="excSecurity.isFeatured('CASEEDIT')
	                          && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterSanierungspartner) !== undefined
	                          && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterSanierungspartner) !== '00000000-0000-0000-0000-000000000000'
	                          " href="javascript:void(0)"
	                             style="color: var(--c-dark);text-decoration: none; display:inline"
	                             (click)="deleteOE('aue_oeID_letzterSanierungspartner')">
	                            {{ getResource('remove') }}
	                          </a>
	                        </span>
						                </ng-container>
					                </div>
				                </div>
			                </div>
		                </div>
	                </div>
                </ng-template>
              </app-exg-tab-v2>
              </div>
            </div>
            <!--ABLAUFPLAN-->
            <div class="flex-row md3-card-on-surface app-space-top"
                 *ngIf="excSecurity.isFeatured('SCHEDULEREAD')">
              <div class="flex-col app-space-bottom_1">
                <div class="grid-1-auto">
                  <h6>{{getResource("Schedule.Text")}} </h6>
                  <button [disabled]="!excSecurity.isFeatured('SCHEDULECREATE')"
                          class="md-btn" (click)="createSchedule()">
                    Ablaufpunkt erstellen
                  </button>
                </div>
                <ng-container *ngIf="!CaseSummary?.workList?.data || CaseSummary?.workList?.isEmpty">
                  <p>Es wurde noch kein Ablaufplan erstellt.</p>
                </ng-container>
                <ng-container *ngIf="CaseSummary?.workList?.data && !CaseSummary?.workList?.isEmpty">
                  <div class="app-subarea" style="margin:0 1rem">
                    <exg-data-list #VCAblaufplanItemList
                                   (RowDblClick)="updateSchedule($event)"
                                   [allowSingleSelection]="false"
                                   [displayState]="0"
                                   [rowSource]="CaseSummary?.workList?.data"
                                   selectKey="apiID"
                                   class="list">
                      <ng-template #rowTemplate let-apItem>
                        <div class="list-row list-row-auto-1 app-list">
	                        <div [class.c-blue]="!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate > 0"
	                             [class.c-orange]="!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate === 0"
	                             [class.c-red]="(!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate < 0) || (apItem.apiFreigabe && apItem.DateDiffSoll_IstDate && apItem.DateDiffSoll_IstDate < 0)"
	                             [class.app-textdone]="apItem.apiFreigabe"
	                             class="typo-center" style="min-width: 70px"
	                        >
		                        <div class="typo-center">
			                        <ng-container *ngIf="!apItem.apiFreigabe">
				                        <i class="fa-xl fa-regular fa-calendar-lines"
				                           *ngIf="apItem.DateDiffSoll_PlanDate > 0 ">
				                        </i>
				                        <i class="fa-xl fa-regular fa-calendar-day"
				                           *ngIf="apItem.DateDiffSoll_PlanDate === 0 ">
				                        </i>
				                        <i class="fa-xl fa-regular fa-calendar-exclamation"
				                           *ngIf="apItem.DateDiffSoll_PlanDate < 0 ">
				                        </i>
			                        </ng-container>
			                        <ng-container *ngIf="apItem.apiFreigabe">
				                        <i class="fa-xl fa-regular fa-calendar"
				                           *ngIf="apItem.DateDiffSoll_IstDate >= 0">
				                        </i>
				                        <i class="fa-xl fa-regular fa-calendar-exclamation"
				                           *ngIf="apItem.DateDiffSoll_IstDate < 0">
				                        </i>
			                        </ng-container>
		                        </div>
		                        <div class="typo-small app-space-top">
			                        <ng-container *ngIf="!apItem.apiFreigabe">
				                        {{
                                  apItem.DateDiffSoll_PlanDate === 0 ? 'Heute' :
                                      apItem.DateDiffSoll_PlanDate > 0 ? 'in ' + apItem.DateDiffSoll_PlanDate + ' T.' :
                                          apItem.DateDiffSoll_PlanDate < 0 ? 'vor ' + apItem.DateDiffSoll_PlanDate + ' T.' : ''
				                        }}
			                        </ng-container>
			                        <ng-container *ngIf="apItem.apiFreigabe && apItem.DateDiffSoll_IstDate < 0">
				                        {{
                                  apItem.DateDiffSoll_IstDate < 0 ? 'übers. ' + apItem.DateDiffSoll_IstDate + ' T.' : ''
				                        }}
			                        </ng-container>
		                        </div>
	                        </div>
	                        <div class="typo-small">
		                        <div class="grid-1-auto">
			                        <div class="typo-container-s-s-q span-2 app-typo-tablecell">
                                <span class="typo-center"
                                      style="text-align: left;">
                                </span>
				                        <span>
                                  <i class="search-filter-action disabled fa-clipboard-check"
                                     flow="right"
                                     [tooltip]="enumSvc.getFieldCaption('Ablaufplan', 'apiFreigabe')"
                                     [class.app-fa-duotone-green]="apItem.apiFreigabe"
                                     [class.fa-duotone]="apItem.apiFreigabe"
                                     [class.fa-light]="!apItem.apiFreigabe">
                                  </i>
                                  <ng-container *ngIf="excSecurity.isFeatured('SCHEDULEMGMT')">
                                    <i class="search-filter-action disabled fa-magnifying-glass"
                                       flow="right"
                                       [tooltip]="enumSvc.getFieldCaption('Ablaufplan', 'apiPruefen')"
                                       [class.fa-duotone]="apItem.apiPruefen"
                                       [class.fa-light]="!apItem.apiPruefen">
                                    </i>
                                    <i class="search-filter-action disabled fa-monitor-waveform"
                                       flow="right"
                                       [tooltip]="enumSvc.getFieldCaption('Ablaufplan', 'apiMonitoring')"
                                       [class.fa-duotone]="apItem.apiMonitoring"
                                       [class.fa-light]="!apItem.apiMonitoring">
                                    </i>
				                            <i class="search-filter-action disabled fa-duotone fa-list-radio"
				                               flow="right"
				                               [tooltip]="getRessource('Ablaufplan.isapiCustom')"
				                               *ngIf="apItem.apiCustom">
					                          </i>
                                    <i class="search-filter-action disabled fa-user-pen fa-duotone"
                                       flow="right"
                                       [tooltip]="getRessource('Ablaufplan.isNotapiCustom')"
                                       *ngIf="!apItem.apiCustom">
						                        </i>
                                  </ng-container>
                                </span>
				                        <q></q>
				                        <ng-container *ngIf="apItem.apiBezeichnung && apItem?.apiBezeichnung.length > 0">
                                  <span [class.app-textdone]="apItem.apiFreigabe">
                                    {{enumSvc.getFieldCaption("Ablaufplan", 'apiBezeichnung')}}
                                  </span>
					                        <span [class.app-textdone]="apItem.apiFreigabe">{{apItem.apiBezeichnung}}</span>
					                        <q></q>
				                        </ng-container>
				                        <span [class.app-textdone]="apItem.apiFreigabe">
                                  {{enumSvc.getFieldCaption("Ablaufplan", 'apiAblaufplanKategorie_enmIdent')}}
                                </span>
				                        <span [class.app-textdone]="apItem.apiFreigabe">
                                  {{enumSvc.getEnumerationText('AblaufplanKategorie', apItem.apiAblaufplanKategorie_enmIdent)}}
                                </span>
				                        <q></q>
				                        <!-- apiSollDatum -->
				                        <span [class.app-textdone]="apItem.apiFreigabe"
				                              [class.c-blue]="!apItem.apiFreigabe && apItem.DateDiffSollDate > 0"
				                              [class.c-orange]="!apItem.apiFreigabe && apItem.DateDiffSollDate === 0"
				                              [class.c-red]="(!apItem.apiFreigabe && (apItem.DateDiffSollDate <= 1)) || (apItem.apiFreigabe && apItem.DateDiffSoll_IstDate && apItem.DateDiffSoll_IstDate < 0)">
                                      {{enumSvc.getFieldCaption("Ablaufplan", 'apiSollDatum')}}
                                </span>
				                        <span [class.app-textdone]="apItem.apiFreigabe"
				                              [class.c-blue]="!apItem.apiFreigabe && apItem.DateDiffSollDate > 0"
                                      [class.c-orange]="!apItem.apiFreigabe && apItem.DateDiffSollDate === 0"
                                      [class.c-red]="(!apItem.apiFreigabe && (apItem.DateDiffSollDate <= 1)) || (apItem.apiFreigabe && apItem.DateDiffSoll_IstDate && apItem.DateDiffSoll_IstDate < 0)">
                                    {{apItem.apiSollDatum | excDate: 'dd.MM.yyyy HH:mm'}}
                                </span>
				                        <q></q>
				                        <!-- apiPlanDatum -->
				                        <ng-container *ngIf="apItem.apiPlanDatum">
												          <span [class.app-textdone]="apItem.apiFreigabe"
												                [class.c-blue]="!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate > 0"
												                [class.c-orange]="!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate === 0"
												                [class.c-red]="!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate < 0">
													          {{enumSvc.getFieldCaption("Ablaufplan", 'apiPlanDatum')}}
	                                </span>
					                        <span [class.app-textdone]="apItem.apiFreigabe"
					                              [class.c-blue]="!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate > 0"
					                              [class.c-orange]="!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate === 0"
					                              [class.c-red]="!apItem.apiFreigabe && apItem.DateDiffSoll_PlanDate < 0">
	                                    {{apItem.apiPlanDatum | excDate: 'dd.MM.yyyy HH:mm'}}
	                                </span>
					                        <q></q>
				                        </ng-container>
				                        <!-- apiIstDatum -->
				                        <ng-container *ngIf="apItem.apiIstDatum">
                                  <span [class.app-textdone]="apItem.apiFreigabe"
                                        [class.c-red]="apItem.apiFreigabe && apItem.DateDiffSoll_IstDate < 0">
                                    {{enumSvc.getFieldCaption("Ablaufplan", 'apiIstDatum')}}
                                  </span>
					                        <span [class.app-textdone]="apItem.apiFreigabe"
					                              [class.c-red]="apItem.apiFreigabe && apItem.DateDiffSoll_IstDate < 0">
                                      {{apItem.apiIstDatum | excDate: 'dd.MM.yyyy HH:mm'}}
                                  </span>
					                        <q></q>
				                        </ng-container>
				                        <ng-container *ngIf="apItem.apiKommentar && apItem.apiKommentar.length >= 0">
                                  <span class="typo-small"  [class.app-textdone]="apItem.apiFreigabe">
                                    {{enumSvc.getFieldCaption("Ablaufplan", 'apiKommentar')}}
                                  </span>
					                        <span  class="typo-small" style="white-space: unset"  [class.app-textdone]="apItem.apiFreigabe">
                                      {{apItem.apiKommentar}}
                                  </span>
					                        <q></q>
				                        </ng-container>
			                        </div>
			                        <div class="list-metadata ">
				                        <div class="typo-right">{{apItem.apiLCU ? apItem.apiLCU : apItem.apiCRU}}</div>
				                        <div
					                        class="typo-right">{{(apItem.apiLCD ? apItem.apiLCD : apItem.apiCRD) | excDate: 'dd.MM.yy HH:mm'}}</div>
			                        </div>
		                        </div>
	                        </div>
                        </div>
                      </ng-template>
                    </exg-data-list>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <!--TABS-->
        <div class="flex-col" style="min-height: 360px">
          <div class="content flex-container lh-1-15">
            <div class="flex-row">
              <div class="flex-col app-space-top md3-card-on-surface" #DivVerlauf
                   style="height: 100%; min-height: 480px">
                <app-exg-tab-v2 [hidden]="CaseSummary?.caseDetails?.isLoading || renderRightTabs"
                   #VCrightTabControl
                   [header]="rightTabs"
                   *ngIf="!CaseSummary?.caseDetails?.isLoading">
                  <ng-template #pages>
                    <div class="content" style="min-height: 480px">
                      <div *ngIf="config.flowTable.state === 2" class="splash empty">
                        <p>{{getTranslation('Es wurden keine Daten gefunden!')}}</p>
                      </div>
                      <exg-data-list [allowSingleSelection]="false"
                                     [displayState]="config.flowTable.state"
                                     [rowSource]="CaseSummary?.flowTable.data"
                                     selectKey="lnkID">
                        <ng-template #rowTemplate let-row>
                          <div class="list-row list-single-line grid-auto-1">
                            <div class="list-avatar nobackground row-span-2" style="cursor: pointer"
                                 (click)="config.openLink(row)"><i
                              class="{{getTranslation('Icons.' + row.lnkTable)}}"></i></div>
                            <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                              <div class="list-metadata" style="margin-left:0">
                                <span style="padding-right: 0.25rem">{{row.Etikett}}</span>
                                <span style="letter-spacing: 0.25rem">
                                  <ng-container *ngIf="row.Etikett === 'Nachricht'">
                                    <i class="fal fa-inbox-in" *ngIf="row.lnkImageUrl.indexOf('In')>-1"></i>
                                    <i class="fal fa-inbox-out" *ngIf="row.lnkImageUrl.indexOf('Out')>-1"></i>
                                    <i class="fal fa-paperclip" *ngIf="row.lnkImageUrl.indexOf('Anhang')>-1"></i>
                                    <i class="fal fa-check" *ngIf="row.lnkImageUrl.indexOf('Done')>-1"></i>
                                    <i class="fal fa-location" *ngIf="row.lnkImageUrl.indexOf('EXAKT')>-1"></i>
                                  </ng-container>
                                  <ng-container *ngIf="row.Etikett === 'Aufgabe'">
                                    <i class="fal fa-check" *ngIf="row.lnkImageUrl.indexOf('Done')>-1"></i>
                                  </ng-container>
                                </span>
                              </div>
                              <div class="list-metadata">
                                <div
                                  class="typo-right">{{row.lnkCRD | excDate: 'Globals.DateTimeFormatShort'}}</div>
                                <div class="typo-right">{{row.lnkCRU}}</div>
                              </div>
                              <div class="span-2"><strong>{{row.lnkName}}</strong></div>
                              <div class="span-2 list-secondary-text"></div>
                            </div>
                          </div>
                        </ng-template>
                      </exg-data-list>
                    </div>
                    <div class="content" style="min-height: 480px">
                      <app-tab-task-attachment
                        *ngIf="!CaseSummary?.caseDetails?.isLoading"
                        [entityID]="CaseSummary?.ID"
                        [entityType]="'case'"
                        [SummaryAttachmentTable]="CaseSummary?.attachmentJagTable"
                        [ConfigAttachmentTable]="config.attachmentJagTable"
                        [AttachmentFolderStates]="openAttachmentFolder"
                        (attachmentFolderStatesChange)="saveAttachmentFolderStates($event)"
                        [Events]="Events"
                        [auftragData]="CaseSummary?.caseDetails?.data"
                        [taskList]="CaseSummary?.taskList.data">
                      </app-tab-task-attachment>
                    </div>
                    <div class="content" style="min-height: 480px"
                         *ngIf="!CaseSummary?.caseDetails?.isLoading && CaseSummary?.caseDetails?.data?.showGDVActions">
                    <app-case-gdv-receipt
                        [caseID]="CaseSummary?.ID"
                        [SummaryGdvReceipt]="CaseSummary?.gdvReceiptList?.data"
                        [SummaryAttachmentTable]="CaseSummary?.attachmentJagTable"
                        [ConfigAttachmentTable]="config.attachmentJagTable"
                        [ConfigGdvReceipt]="config.gdvReceiptList"
                        [tableDrawerIsLoading]="dataSummmaryLoaded"
                        [Events]="Events">
                      </app-case-gdv-receipt>
                    </div>
                    <div class="content" style="min-height: 480px">
                      <app-tab-report-details
                        *ngIf="!CaseSummary.isLoading"
                        [entityID]="CaseSummary?.ID"
                        [SummaryCalculationTable]="CaseSummary?.calculationVersion.data"
                        [SummaryQuestionnaireTable]="CaseSummary?.questionnaireVersion.data"
                        [SummaryPhotoDocumentationTable]="CaseSummary?.photoDocumentation.data"
                        [ReportFolderStates]="openReportFolder"
                        (reportFolderStatesChange)="saveReportFolderStates($event)"
                        [Events]="Events"
                      >
                      </app-tab-report-details>
                    </div>
                    <div class="content" style="min-height: 480px">
                      <app-tab-task-receipt *ngIf="!CaseSummary?.caseDetails?.isLoading"
                                            [ConfigReceiptTable]="config.receiptList"
                                            [SummaryReceiptTable]="CaseSummary?.receiptList"
                                            [tableDrawerIsLoading]="CaseSummary?.caseDetails?.isLoading"
                                            [Events]="Events">
                      </app-tab-task-receipt>
                    </div>
                    <div class="content" style="min-height: 480px">
                      <app-tab-task-leistung *ngIf="!CaseSummary?.caseDetails?.isLoading"
                                             [ConfigLeistungTable]="config.leistungList"
                                             [SummaryLeistungTable]="CaseSummary?.leistungList"
                                             [tableDrawerIsLoading]="CaseSummary?.caseDetails?.isLoading"
                                             [Events]="Events">
                      </app-tab-task-leistung>
                    </div>
                    <div class="content" style="min-height: 480px">
                      <exg-data-list #VCtaskList
                                     selectKey="vorgID"
                                     [displayState]="CaseSummary?.taskList?.data && CaseSummary?.taskList?.data.length > 0 ? 0 : 2"
                                     [rowSource]="CaseSummary?.taskList?.data || []"
                                     [selectSourceRows]="config.taskList.selectedObjects"
                                     (RowChange)="config.taskList.rowChange($event)"
                                     (ItemSelect)="config.taskList.itemSelect($event)">
                        <ng-template #rowTemplate let-task>
                          <div class="list-row-auto-1 app-cursor-pointer"
                               (dblclick)="config.onClickOpenTaskCheckview(task)"
                               [class.active]="config.taskList.selectedObjects[0] === task">
                            <div></div>
                            <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                              <div class="list-metadata" style="margin-left:0">
                                <div>
                                  {{enumSvc.getEnumerationText('VorgangStatus', task.vorg_enmIdent_VorgangStatus)}} -
                                  {{enumSvc.getEnumerationText('VorgangTyp', task.vorg_enmIdent_VorgangTyp)}}
                                </div>
                                <div>Auftraggeber: {{task.auAuftraggeberShort}}
                                     Schadenart: {{enumSvc.getEnumerationText('Schadenart', task.aue_enmIdent_SchadenArt)}}</div>
                              </div>
                              <div class="list-metadata ">
                                <div
                                  class="typo-right">{{task.vorgLCD | excDate: 'Globals.DateTimeFormatShort'}}
                                </div>
                              </div>
                              <div style="height: 30px">
                                <span class="typo-center">
                                  <span [tooltip]="'Nicht Geprüft'" flow="right">
                                    <i class="fa-light fa-xmark c-red" style="font-size: 14px" *ngIf="!task.vorgCKD"></i>
                                  </span>
                                  <span [tooltip]="'Geprüft'" flow="right">
                                    <i class="fa-light fa-check c-green" style="font-size: 14px" *ngIf="task.vorgCKD"></i>
                                  </span>
                                </span>
                                      <span class="app-space-left">
                                  <strong>{{task.vorgNr}}</strong>
                                </span>
                              </div>
                              <div class="typo-right">
                                <i class="search-action fa-regular fa-chevron-right"
                                   *ngIf="config.taskList.selectedObjects[0] === task"
                                   (click)="config.onClickOpenTaskCheckview(task)">
                                </i>
                              </div>
                              <div class="span-2 typo-container-s-s-q app-space-left_none">
                                <ng-container *ngIf="task.vorgBeschreibung && task.vorgBeschreibung.length > 0">
                                  <span style="width: 148px">
                                    {{enumSvc.getFieldCaption('Vorgang', 'vorgBeschreibung')}}:
                                  </span>
                                  <span class="typo-left"
                                        *ngIf="config.taskList.selectedObjects[0] === task">
                                    {{task.vorgBeschreibung}}
                                  </span>
                                  <span class="typo-left"
                                        *ngIf="config.taskList.selectedObjects[0] !== task">
                                    {{task.vorgBeschreibung.slice(0, 48)}}
                                    {{task.vorgBeschreibung.length > 48 ? '...' : ''}}
                                  </span>
                                  <q></q>
                                </ng-container>
                                <ng-container *ngIf="task.vorgBearbeiter && task.vorgBearbeiter.length > 0">
                                   <span style="width: 148px">
                                   {{enumSvc.getFieldCaption('Vorgang', 'vorgBearbeiter')}}:
                                  </span>
                                  <span class="typo-left">
                                    {{task.vorgBearbeiter}}
                                  </span>
                                  <q></q>
                                </ng-container>

                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </exg-data-list>
                    </div>
                    <div class="content" style="min-height: 480px">
                      <exg-data-list [allowSingleSelection]="false"
                                     [rowSource]="CaseSummary?.dialogueQuestions?.data"
                                     selectKey="dfID">
                        <ng-template #rowTemplate let-row>
                          <div class="list-row list-single-line-auto-1 typo-small">
                            <div><strong>{{row.dfText}}</strong></div>
                            <div class="list-secondary-text"
                                 *ngIf="row.deValue && row.deValue.length > 0">{{row.deValue}}</div>
                            <div class="list-secondary-text" style="font-style: italic"
                                 *ngIf="!row.deValue || row.deValue.length === 0">&lt;&lt;Die Frage wurde noch nicht
                                                                                  beantwortet&gt;&gt;
                            </div>
                          </div>
                        </ng-template>
                      </exg-data-list>
                    </div>
                  </ng-template>
                </app-exg-tab-v2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!--ICON BAR RIGHT-->
  <div class="app-drawer md3-card-on-surface app-height-auto app-space-top" style="overflow: visible">
    <i class="disabled search-filter-action"></i>
    <i class="search-filter-seperator"></i>
    <i (click)="openWorkspace()"
	     class="search-filter-action fal fa-business-time"
	     [tooltip]="getRessource('tooltip.openWorkspace')" flow="left">
	  </i>
	  <i class="search-filter-seperator"></i>
    <app-exg-dropdown *ngIf="!editMode">
      <ng-template #hostTemplate>
        <i class="search-filter-action fal fa-ellipsis-v"
           [class.disabled]="!isWorkflowActive()"
           [tooltip]="!isWorkflowActive()?'Keine Workfloweinträge verfügbar':'Workflowmenü'" flow="left">
        </i>
      </ng-template>
      <ng-template #contentTemplate let-popup>
        <div *ngFor="let row of workFlowMenu">
          <div class="list-row list-single-line  typo-small" style="cursor:pointer" (click)="row.click(); popup.close()"
               *ngIf="row.visible">{{row.caption}}</div>
        </div>
      </ng-template>
    </app-exg-dropdown><!--[disabled]="CaseSummary?.isLoading"-->
    <i (click)="config.openEditMode()" class="search-filter-action fal fa-pencil"
       *ngIf="!editMode"
       [class.disabled]="CaseSummary?.isLoading || !excSecurity.isFeatured('CASEEDIT')"
       [tooltip]="getResource('EditMode')" flow="left"></i>
    <i (click)="config.cloneCase()" class="search-filter-action fal fa-clone"
       *ngIf="!editMode && excSecurity.isFeatured('CASECLONE')"
       [class.disabled]="CaseSummary?.isLoading"
       [tooltip]="'Auftrag klonen'" flow="left">
    </i>
    <i (click)="config.saveEditMode()" class="search-filter-action fal fa-floppy-disk"
       *ngIf="editMode"
       [class.disabled]="CaseSummary?.isLoading  || !excSecurity.isFeatured('CASEEDIT')"
       [tooltip]="getResource('SaveEditMode')" flow="left"></i>
    <i (click)="config.cancelEditMode()" class="search-filter-action fal fa-xmark"
       *ngIf="editMode"
       [class.disabled]="CaseSummary?.isLoading"
       [tooltip]="getResource('CancelEditMode')" flow="left"></i>
    <i class="search-filter-seperator"></i>
    <app-exg-dropdown *ngIf="!editMode" position="underleft">
      <ng-template #hostTemplate>
        <i class="search-filter-action fal fa-plus"
           [tooltip]="'Hinzufügen'" flow="left"
           [class.disabled]="CaseSummary?.isLoading"></i>
      </ng-template>
      <ng-template #contentTemplate let-popup>
        <div class="content" style="max-height: 500px">
          <div (click)="config.newReport(); popup.close();" class="md-menu-item">Bericht</div>
          <div (click)="config.newServiceRecord(); popup.close();"
               *ngIf="excSecurity.isFeatured('DEVELOPMENT')"
               class="md-menu-item">
            Leistungsaufstellung
          </div>
          <div *ngIf="!(CaseSummary?.defaultMessages?.data.length > 0)"
               (click)="config.newMessage(); popup.close();"
               class="md-menu-item">Nachricht
          </div>
          <app-exg-dropdown *ngIf="CaseSummary?.defaultMessages?.data.length > 0" [adaptiveHeightActive]="true">
            <ng-template #hostTemplate>
              <div class="md-menu-item">Nachricht...</div>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <div (click)="config.newMessage();popup.close();" class="md-menu-item typo-left">Leere Nachricht</div>
              <ng-container *ngFor="let row of CaseSummary?.defaultMessages?.data">
                <div (click)="config.newDefaultMessage(row.dmsgID);popup.close();"
                     class="md-menu-item typo-left">{{row.dmsgBezeichnung}}</div>
              </ng-container>
            </ng-template>
          </app-exg-dropdown>
          <div *ngIf="excSecurity.isFeatured('NTZEDIT')"
               (click)="config.newNote();popup.close();" class="md-menu-item">
            Notiz
          </div>
          <div (click)="config.showAttachmentUploadModal(); popup.close();" class="md-menu-item">Anlage</div>
          <div *ngIf="excSecurity.isFeatured('TASKCREATE')" (click)="createNewTask(); popup.close();"
               class="md-menu-item">Vorgang
          </div>
        </div>
      </ng-template>
    </app-exg-dropdown>
    <i class="search-filter-action fal fa-image" (click)="config.showAttachmentPreview()"
       [class.disabled]="CaseSummary?.isLoading"
       [tooltip]="'Anlagen ansehen'"
       flow="left"></i>
    <i (click)="config.showHistory()" class="search-filter-action {{getResource('Tabs.History.Icon')}}"
       [class.disabled]="CaseSummary?.isLoading"
       [tooltip]="'Historie'" flow="left"></i>
	  <ng-container
		  *ngIf="excSecurity.isFeatured('HISTORYEXTREAD')">
		  <i class="search-filter-action fa-light fa-list-timeline"
		     *ngIf="excSecurity.isFeatured('HISTORYEXTREAD')"
		     (click)="OpenDetailHistoryModal()"
		     [class.disabled]="CaseSummary.isLoading"
		     [tooltip]="'History'"
		     flow="left"></i>
	  </ng-container>
    <i class="search-filter-seperator"></i>
    <i class="search-filter-action fa-light fa-folders"
       *ngIf="excSecurity.isFeatured('DOCUMENTMGMT')"
       (click)="openFileOverview()"
       [tooltip]="'Dokumenten Manager'"
       [class.disabled]="CaseSummary.isLoading"
       flow="left"></i>
    <i class="search-filter-action fa-light fa-screwdriver-wrench"
       *ngIf="excSecurity.isFeatured('REPORTBUILDER')"
       (click)="openReportBuilder()"
       [tooltip]="'Neuen Report erstellen'"
       [class.disabled]="CaseSummary.isLoading"
       flow="left"></i>
  </div>
</div>
<!--Loading-->
<ng-container *ngIf="CaseSummary?.caseDetails?.isLoading">
  <div class="splash loading">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</ng-container>
